export default __webpack_public_path__ + "static/media/spot-mobile.25e1a608.svg";